import React, { useContext, useEffect, useState } from "react";


import DashboardMetrics from "./dashboard";
import { fetchLearningsDashboardReport, fetchLearningsInsightsReport, fetchLearningsLeaderboardReport, fetchLearningsPopularReport, fetchLearningsSkillsReport } from "src/redux/actions/coaching/reports";
import { useDispatch } from "react-redux";
import LeaderboardReport from "./leaderboard";
import MostEnrolledReport from "./enrollments";
import InsightsReport from "./insights";
import { useSelector } from "react-redux";
import SkillsReport from "./skills";
import { CourseReportContext } from "../../context";

import _ from "lodash";
import styles from "./learnings.module.scss";

const LearningsReport = () => {
  const dispatch = useDispatch();

  const user = useSelector((state: any) => _.get(state, "users.me.id", null));

  const reportContext = useContext(CourseReportContext);  

  useEffect(() => {
    
    const { user, userGroups, skills, startDate, endDate } = reportContext;
    const groupIds: string[] = _.map(userGroups, (group) => group.id) || [];
    const skillsIds: string[] = _.map(skills, (skill) => skill.id as string) || [];

    const request = {
      page: 0,
      limit: 10,
      user: user,
      userGroups: groupIds,
      skills: skillsIds,
      startDate: startDate,
      endDate: endDate,
    };

    dispatch(fetchLearningsDashboardReport(request));
    dispatch(fetchLearningsLeaderboardReport(request));
    dispatch(fetchLearningsPopularReport(request));
    dispatch(fetchLearningsInsightsReport(request));
    dispatch(fetchLearningsSkillsReport(request))
  }, [reportContext]);

  return (
    <div className={styles.container}>
      <DashboardMetrics />
      <LeaderboardReport />
      <SkillsReport />
      <MostEnrolledReport />
      <InsightsReport />
    </div>
  );
};

export default LearningsReport;
